<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> {{$t('pages.dailyPower.breadcrumb')}} </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.dailyPower.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.dailyPower.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.dailyPower.total')}}
                    <el-input v-model="totalWeight" class="handle-select" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="$t('pages.dailyPower.rangeSeparator')" :start-placeholder="$t('pages.dailyPower.startDate')" :end-placeholder="$t('pages.dailyPower.endDate')" :picker-options="pickerOptions" class="handle-select mr10" style="width: 300px"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.dailyPower.type')" class="handle-select mr10">
                    <el-option v-for="item in electricityTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.dailyPower.search')}}</el-button>
            </div>
        </div>

            <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" :height="tableHeight">
                <el-table-column type="index" width="50" :label="$t('pages.dailyPower.index')"></el-table-column>
                <el-table-column sortable prop="date" :label="$t('pages.dailyPower.date')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.date | formateData }}
                </template>
            </el-table-column>
            <el-table-column prop="electricityTypeName" :label="$t('pages.dailyPower.type')"></el-table-column>
            <el-table-column :label="$t('pages.dailyPower.dayPower')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{
                            scope.row.electricityDay
                        }}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            tableHeight: window.innerHeight * 0.75,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            electricityTypeArr: [{
                    id: 0,
                    name: "全部",
                },
                {
                    id: 1,
                    name: "煤矿总关口",
                },
                {
                    id: 2,
                    name: "井下供电关口",
                },
                {
                    id: 3,
                    name: "主运输设备供电关口",
                },
            ],
            logRecords: [],
            multipleSelection: [],
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                balanceId: 0
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
        this.query.daterange = [start, end];
            this.electricityTypeArr = [
                { id: 0, name: this.$t('pages.dailyPower.all') },
                { id: 1, name: this.$t('pages.dailyPower.type1') },
                { id: 2, name: this.$t('pages.dailyPower.type2') },
                { id: 3, name: this.$t('pages.dailyPower.type3') }
            ];
        this.getBalance();
        this.getData();
    },
    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning(this.$t('pages.dailyPower.dateRequired'));
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
            this.$zybhttp
                .post('ProdInquiry/DailyPowerData', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.totalWeight = res.data.msg;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dailyPower.fetchError')));
        },
        getBalance() {
            this.$zybhttp
                .post('Balance/GetList', {
                    Field3: '1',
                    Field4: '3'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{
                                id: 0,
                                name: this.$t('pages.dailyPower.all')
                            }]
                            .concat(d)
                            .sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dailyPower.fetchError')));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        },
        printlist() {
            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.dailyPower.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.dailyPower.index'),
                        columnSize: `8%`
                    },
                    {
                        field: 'date',
                        displayName: this.$t('pages.dailyPower.date'),
                        columnSize: `20%`
                    },
                    {
                        field: 'electricityTypeName',
                        displayName: this.$t('pages.dailyPower.type'),
                        columnSize: `20%`
                    },
                    {
                        field: 'electricityDay',
                        displayName: this.$t('pages.dailyPower.dayPower'),
                        columnSize: `10%`
                    },
   
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:center;padding:5px;10px;',
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    this.$t('pages.dailyPower.printTitle') + name + '.xlsx'
                );
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
